import { useMemo } from 'react';

import { useStore } from '@playbooks/contexts';
import { useAction } from '@playbooks/hooks';
import { TextEditorBasic } from '@playbooks/molecules/editors';
import { Button } from '@playbooks/ui/components/button';
import { Field, FieldLabel } from '@playbooks/ui/components/field';
import { Icon } from '@playbooks/ui/components/icon';

const DescriptionFormGroup = ({ type, value, setValue }) => {
	const store = useStore();

	// Computed
	const url = useMemo(() => {
		switch (type) {
			case 'template':
				return `/workspaces/${value.owner?.uuid}/templates/${value.uuid}/ai`;
			case 'category':
				return `/categories/${value.uuid}/ai`;
		}
	}, [value]);

	// Actions
	const [onAi, aiTask] = useAction(async () => {
		const response = await store.request({ url, params: { type: 'description' } });
		setValue(response.message?.content);
	});

	// Render
	return (
		<Field>
			<span className='flex-between w-full'>
				<FieldLabel>Description</FieldLabel>
				<Button variant='secondary' size='xs' isLoading={aiTask.running} onClick={onAi} className='text-xs'>
					<Icon data-icon='inline-start' type='far' icon='wand-magic-sparkles' aria-hidden />
				</Button>
			</span>
			<TextEditorBasic
				value={value.description || ''}
				placeholder=''
				onChange={description => (value.id ? setValue(description) : null)}
				className='max-h-[400px] overflow-y-scroll custom-scrollbar'
			/>
		</Field>
	);
};

export { DescriptionFormGroup };
